import { ActionsFactory } from '../factories/actions.factory';
import { ActionTypesFactory } from '../factories/actionTypes.factory';

export const PlacesActions = new ActionsFactory('places', ActionTypesFactory('PLACES'));
